import { createFileRoute } from '@tanstack/react-router'

import { OpenWorkspacePage } from '@/features/account/pages/open-workspace-page'

/** Authenticated, unlisted staff utility. Authorization is enforced by the workspace probe. */
export const Route = createFileRoute('/_ws/workspaces/open')({
  component: OpenWorkspacePage,
})
